import React, {useState, useContext, useRef} from 'react';
import { IonContent, IonText, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonDatetime, IonFooter, IonTextarea } from '@ionic/react';
import { IonSlides, IonSlide, IonLabel } from '@ionic/react';

//import { EnterPasswordModal } from './Modal_EnterPassword';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import {PayModal_JobBoard} from '../../../zPublic/components/Modal_Pay_JobBoard';

import '../../../../css/qavaApp.css'
import '../../../css/layout.css'

export function CreateRequisitionModal (props) {

    //alert('inside CreateEmployeeModal');
    //alert(props.openModal);

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [showPasswordModal, setShowPasswordModal] = useState(false);
    //let [enteredPassword, setEnteredPassword] = useState('');
    let [selectedFile, setSelectedFile] = useState(null);


    
    let [merchantFirstName, setMerchantFirstName] = useState('');
    let [merchantLastName, setMerchantLastName] = useState('');
    let [mobileNumber, setMobileNumber] = useState('');
    let [merchantCompanyName, setMerchantCompanyName] = useState('');
    let [merchantCity, setMerchantCity] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    let [merchantBusinessType, setBusinessType] = useState('T4');


    let [openPayModal, setOpenPayModal] = useState(false);

    let [saveEvent, setSaveEvent] = useState([]);

    let employeeCompanyRoleRef = useRef('individual_contributor');
    let requisitionNameRef = useRef();
    let requisitionResponsibilitiesRef = useRef();
    let requisitionQualificationsRef = useRef();
    let applicationDeadlineRef = useRef();

    let selectedFileRef = useRef();

    function createJobReqisition(enteredPassword)
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', '--');
        formData.append('user', acctID);
        formData.append('xEmployeeCompanyRole', employeeCompanyRoleRef.current.value);

        formData.append('xRequisitionName', requisitionNameRef.current.value);
        formData.append('xRequisitionResponsibilities', requisitionResponsibilitiesRef.current.value);
        formData.append('xRequisitionQualifications', requisitionQualificationsRef.current.value);
        formData.append('xRequisitionDeadlineDate', applicationDeadlineRef.current.value);

        formData.append('xEnterAdminPassword', enteredPassword);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74500_createRequisition',
                user: acctID,
                xEmployeeCompanyRole: employeeCompanyRoleRef.current.value,
                xRequisitionName: requisitionNameRef.current.value,
                xRequisitionResponsibilities: requisitionResponsibilitiesRef.current.value,
                xRequisitionQualifications: requisitionQualificationsRef.current.value,
                xRequisitionDeadlineDate: applicationDeadlineRef.current.value,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            
            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function saveUploadedFile(event) {
    
        //alert(event);
        
        if(event.target.files === null)
        {
            selectedFileRef.current.value = "/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg";
            //setSelectedFile("/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg")

        }
        else
        {
            selectedFileRef.current.value = event.target.files[0];
            //setSelectedFile(event.target.files[0]);
        }


    }

    /*handleCreateEmployeeCompanyRole(e) 
    {   
        e.persist(); 
        employeeCompanyRoleRef.current.value = e.target.value;

    }*/
    function handlePostJob(event)
    {

            setSaveEvent(event);
            setOpenPayModal(true);

    }
    function onSubmitPasswordHandler(enteredPassword)
    {
       // alert('In onSubmitPasswordHandler');
        //alert(enteredPassword);

        //setEnteredPassword(event);
        createJobReqisition(enteredPassword);
    }

    function closeModalHandler() {

        props.closeModal(false);
    }
    //alert('In create post');

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonHeader style={{color: "black"}}>
                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <IonText className='professional-input'>CREATE REQUISITION</IonText>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonHeader>
        <IonContent className='grid_content_details'>
                <IonGrid>
                    <IonRow>
                    <IonLabel for="employeeRole">Requisition Role </IonLabel>
                </IonRow>
                    <IonCol >
                        <select name="employeeRole" id='employeeRole' ref={employeeCompanyRoleRef }>
                            <option value='individual_contributor'>Individual Contributor</option>
                            <option value='front_desk'>Front Desk</option>
                            <option value='cleaning_service'>Cleaning Services</option>
                            <option value='manager'>Manager</option>
                        </select>
                    </IonCol>
                <IonRow>
                    <IonCol>
                        <IonLabel>Requisition Name: </IonLabel>
                        <IonInput className='professional-input' placeholder='Enter Name' ref={ requisitionNameRef }></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <IonLabel>Requisition Responsibilities: </IonLabel>
                        <IonTextarea className='professional-input' cols="50" rows="10" placeholder='Enter Position Responsibilites' ref={ requisitionResponsibilitiesRef }></IonTextarea>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <IonLabel>Requisition Qualifications: </IonLabel>
                        <IonTextarea className='professional-input' cols="50" rows="10" placeholder='Enter Position Qualifications' ref={ requisitionQualificationsRef }></IonTextarea>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                            <IonLabel>Application Deadline </IonLabel>

                            {authenticatedMerchent_context.device == 'mobile' && <IonDatetime className='professional-input' displayFormat='MMM DD, YYYY' placeholder='Select Deadline' ref={applicationDeadlineRef}>  </IonDatetime> }         {/*text={startDateRange.toLocaleString('en-us', {month: 'long', day: '2-digit'}) +', '+startDateRange.getFullYear()} */}
                            {authenticatedMerchent_context.device == 'desktop' &&  <IonInput className='professional-input' type='date' placeholder='Select Deadline' ref={applicationDeadlineRef}> </IonInput>  }
                    </IonCol>
                </IonRow>
            </IonGrid>

        {openPayModal == true && <PayModal_JobBoard openModal={ openPayModal } closeModal={() => closeModalHandler()} payCloseModal={(event) => setOpenPayModal(event)} data={{
                status: 'create_order_internal',
                companyId: '1',
                companyPhoneNumber: mobileNumber,
                mtnCompanyPhoneNumber: mobileNumber,
                cartList:[{ id: "00",
                            name: "JOB POST - "+merchantCompanyName+ " - "+ requisitionNameRef.current.value,
                            price: "50.00",
                            quantity: 1}],
                firstName: merchantFirstName, 
                lastName: merchantLastName,
                merchantCompanyName: merchantCompanyName,
                merchantCity: merchantCity,
                merchantBusinessType: merchantBusinessType,
                mobileNumber: mobileNumber,
                payeeMessage: 'Job Post Payment',
                cartSubtotal: 50.00,
                cartCheckoutTotal: 50.00,
                paymentType: 'mm',
                payment_amount: 50.00,
                //cartLatitude: cartLatitude,
                //cartLongitude: cartLongitude,
                //storefront: storefront,
                requisitionEvent: saveEvent,
                }}></PayModal_JobBoard>}

        </IonContent>

        <IonFooter className='Modal_Footer'>
            <IonGrid>
                <IonRow>
                    <IonCol>
                        {/*<IonButton onClick={() => setShowPasswordModal(true)}>Submit</IonButton>*/}
                        <IonButton onClick={() => handlePostJob([employeeCompanyRoleRef.current.value, requisitionNameRef.current.value, requisitionResponsibilitiesRef.current.value, requisitionQualificationsRef.current.value, applicationDeadlineRef.current.value])}>Submit</IonButton>
                    
                    </IonCol>
                    <IonCol>
                        <IonButton onClick={() => closeModalHandler(false)}>Cancel </IonButton>
                    </IonCol>
                </IonRow>
            </IonGrid>
        </IonFooter>
        </IonModal>) : null}
    </React.Fragment>
    )
}